import React, { useState, useEffect } from 'react';

const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Calculate the total scrollable height
      const scrollableHeight = documentHeight - windowHeight;
      
      // Calculate progress percentage
      const progress = scrollableHeight > 0 
        ? (scrollTop / scrollableHeight) * 100 
        : 0;
      
      setScrollProgress(Math.min(100, Math.max(0, progress)));
    };

    // Update on scroll
    window.addEventListener('scroll', updateScrollProgress, { passive: true });
    
    // Update on resize (in case content height changes)
    window.addEventListener('resize', updateScrollProgress, { passive: true });
    
    // Initial calculation
    updateScrollProgress();

    return () => {
      window.removeEventListener('scroll', updateScrollProgress);
      window.removeEventListener('resize', updateScrollProgress);
    };
  }, []);

  return (
    <div 
      className="fixed top-0 left-0 w-full h-1 bg-transparent z-[1003] pointer-events-none"
    >
      <div
        className="h-full bg-[#00d690] transition-all duration-150 ease-out"
        style={{
          width: `${scrollProgress}%`,
          boxShadow: '0 2px 4px rgba(0, 214, 144, 0.3)'
        }}
      />
    </div>
  );
};

export default ScrollProgressBar;

